import styles from './material-tab-item.module.css';

interface MaterialTabItemProps {
  index: number;
  materialCode: string | number;
  materialDesc: string;
  unit: string;
  qty: string | number;
}

const MaterialTabItem: React.FC<MaterialTabItemProps> = ({
  materialCode,
  materialDesc,
  qty,
  unit,
  index,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.caption}>Material No.{index}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.description}>
          <span>Material Code</span>
          <span>{materialCode}</span>
        </div>
        <div className={styles.description}>
          <span>Material Description</span>
          <span>{materialDesc}</span>
        </div>
        <div className={styles.description}>
          <span>Unit</span>
          <span>{unit}</span>
        </div>
        <div className={styles.description}>
          <span>Qty.</span>
          <span>{qty}</span>
        </div>
      </div>
    </div>
  );
};

export default MaterialTabItem;
